<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-14 15:07:13
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\material\components\detail.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading="loading" :visible="visible" size="75%" :destroy-on-close="true" :wrapper-closable="false"
    :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看物料详情</div>
      <el-button plain @click="$emit('close')"> 返回 </el-button>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" label-suffix=":" :model="form" label-width="160px">
        <el-form-item label="物料分组" prop="materialGroupId">
          {{ form.materialGroupName }}
        </el-form-item>
        <el-form-item label="物料名称" prop="materialName">
          {{ form.materialName }}
        </el-form-item>
        <el-form-item label="物料编码" prop="materialCode">
          {{ form.materialCode }}
        </el-form-item>
        <el-form-item label="物料规格型号" prop="specification">
          {{ form.specification }}
        </el-form-item>
        <el-form-item label="货号" prop="itemNo">
          {{ form.itemNo }}
        </el-form-item>
        <el-form-item label="单位" prop="baseUnit">
          {{ form.baseUnit }}
        </el-form-item>
        <el-form-item label="存储温度" prop="storageTemperature">
          {{ form.storageTemperature }}
        </el-form-item>
        <el-form-item label="目录价" prop="listPrice">
          {{ form.listPrice }}
        </el-form-item>
        <el-form-item label="促销价" prop="promotionPrice">
          {{ form.promotionPrice }}
        </el-form-item>
        <el-form-item label="有效期" prop="time">
          {{ form.time }}
        </el-form-item>
        <el-form-item label="有效期单位" prop="unit">
          {{ form.unit }}
        </el-form-item>
        <el-form-item label="是否禁用" prop="forbidStatus">
          {{ form.forbidStatus === 'Y' ? '是' : "否" }}
        </el-form-item>
      </el-form>
    </el-card>
  </el-drawer>
</template>

<script>
import {
  getMaterialInfo
} from '@/api/material'
export default {
  name: 'MaterailDetail',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    materialData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      form: {},
    }
  },
  created() {
    getMaterialInfo(this.materialData.id).then((res) => {
      this.form = res.data
    }).finally(() => {
      this.loading = false
    })
  }
  // 生命周期 - 创建完成（可以访问当前this实例）
}
</script>
<style scoped>
.grid-box>>>.el-form-item .el-form-item__label {
  line-height: 2.5 !important;
}
</style>
